import { toast } from '@mx/vix';
import { normalizeError } from '@mx/pay-common';
import { env, metricPoints, monitor, postUniteSign, signPay, CallbackPayResultSource } from '@/common';
import { showErrorModal } from './errorModal';
import { pollingQueryOrder } from './queryOrder';
import { getSignResultPage, callbackSignResult } from './signResult';
import { lx } from '@/analytic';
import { bids } from '@/analytic/lx-constants';

/**
 * 支付流程签约 - 履约层
 * @param params
 */
function fetchSignPay(params: SignPayParamsType) {
  signPay(params)
    .then((res) => {
      const { retry_count: retryCount, retry_interval: retryInterval, pay_fail_action: payFailAction } = res;
      env.setPayFailAction(payFailAction);
      // 轮询支付结果
      pollingQueryOrder(retryCount || 8, retryInterval || 1000);
    })
    .catch((error) => {
      // 签约过程的 loading 加载从 guideSign 开始，到此接口一致有 loading，如果接口异常则隐藏 toast
      toast.hide();
      showErrorModal({ resultData: error });
      monitor.captureAjaxErrorMessage('[api]signPay签约并支付接口请求失败', { error: normalizeError(error) });
    });
}

/**
 * 独立签约请求 - 会员
 * @param params
 */
function uniteSign(params: UniteSignParamsType & GuideSignParamsType) {
  postUniteSign(params)
    .then((data) => {
      if (data.signed) {
        lx.mc(bids.signSuccessMC);
        monitor.reportMetric(metricPoints.signedSuccess, { signStatus: data.signed });
        if (env.hideHalfPage) {
          // 如果存在 hideHalfPage 参数时直接回调
          callbackSignResult(CallbackPayResultSource.nonShowCouponDialog);
        } else {
          // 查询签约状态
          getSignResultPage();
        }
      }
    })
    .catch((error: any) => {
      // 签约过程的 loading 加载从 guideSign 开始，到此接口一致有 loading，如果接口异常则隐藏 toast
      toast.hide();
      showErrorModal({ resultData: error });
      monitor.captureAjaxErrorMessage('[api]独立签约接口返回异常', { error });
    });
}

/**
 * 签约服务包含独立签约和支付流程签约
 * @param params
 */
export function fetchSignDefer() {
  const { state = '', bizSerialId = '' } = env.guideSignResponseData;
  // 独立签约
  if (env.isIndependenceSign) {
    const uniteSignParams = {
      ...env.guideSignParams,
      state,
      bizSerialId,
      utmSource: env.utmSource,
      riskParams: env.riskParams,
      validateToken: env.validateToken,
    };
    uniteSign(uniteSignParams);
  } else {
    // 支付流程签约
    const signPayParams: SignPayParamsType = {
      ...env.inpayBasicBusinessParams,
      auth_no: env.coreBusinessParams.authNo,
      guide_state: state,
      biz_serial_no: bizSerialId,
      validate_token: env.validateToken,
      utm_source: env.utmSource,
      openType: env.openType,
    };
    fetchSignPay(signPayParams);
  }
}
